import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';

const Entrepreneurship = () => {
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Entrepreneurship</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Entrepreneurship
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={['Entrepreneurship']}
              currentClassName="active">
              <li><a href="#Entrepreneurship">Entrepreneurship </a></li>
            </Scrollspy>
            
          </div>

        </div>
        <div className="main_lab_style">
          <section id="Entrepreneurship">
            
            <section id="Problem">
              <h1>
                Problem Definition
              </h1>

              <p>There are three main challenges in the drug development industry: <em><u>drug resistance</u></em>, <em><u>high cost</u></em>, and <em><u>environmental pollution</u></em>.</p>
              <p>Firstly, <strong><em>drug-resistant</em></strong> has emerged in recent decades. One common type of anticancer drug candidate in drug discovery is metal-containing complex such as platinum and copper complexes. They have long been a &ldquo;magic bullet&rdquo; in treating various types of cancers. However, drug resistance of the cancer cells has greatly reduced their effectiveness, and some cancer types can no longer be treated. The high cost of the drug industry also hinders its development.</p>
              <p>The conventional techniques applied in drug development is semi-chemical synthesis. A large number of analogues can be generated by constructing a small molecule library with combinatorial chemistry. In fact, this is not a cost-effective method due to the low yield resulting from the complicated synthetic route. The <strong><em>high cost </em></strong>of developing a drug through chemical synthesis makes most of the drugs unaffordable to cancer patients, especially those from under-developed countries.</p>
              <p>Last but not least, <strong><em>environmental conservation factors</em></strong> are also the main concern in recent years. Traditional synthetic chemistry often relies on toxic reagents, which may cause harmful effects on the environment.</p>

            </section>
            <br /><br />
            <section id="Solution">
              <h1>
                Our Solution
              </h1>
              <p>On the contrary, <strong>natural product (NP) drugs</strong> can help to alleviate the situation. NPs have a huge enzymatic repertoire in which <u>drug resistance can be overcome</u> by the enormous structural diversity. Moreover, biosynthetic engineering combined with advanced fermentation technologies can help to increase the yield and lower the production cost. Hence, NP drugs can easily achieve a lower and <u>affordable price</u>. Biosynthetic technology also will not involve the usage of any toxic compounds. It is therefore a <u>more eco-friendly</u> substitute of the more traditional methods.</p>
              <p>Collectively, synthetic biology technology has the capability to tackle various industrial challenges, for instance, better structural diversity and activity of the biosynthetic products, higher cost-effectiveness, and greater eco-friendliness. And we want to take a step in the direction to grow our project and make it available to the public.</p>

              
            </section>
            <br /><br />
            <section id="Business">
              <h1>
                Business Plan
              </h1>
              <p><strong>HK Tech 300</strong></p>
              <p><strong><u>HK Tech 300</u></strong> is a large-scale flagship innovation and entrepreneurship programme organised by City University of Hong Kong (CityU) for aspiring entrepreneurs among CityU students, alumni, research staff to launch start-ups and ignite their entrepreneurship journey. The programme aims to create 300 start-ups in three years, providing educational and growth opportunities for CityU students, and translating CityU research results and intellectual properties into practical applications.</p>
              <p>&nbsp;This programme follows 4 primary stages:</p>
              <ol>
                <li><em>Recruitment and Training</em></li>
                <li><em>Seeding &ndash; HK$ 100,000 Seed Fund</em></li>
                <li><em>Incubating &ndash; HK$ 1 Million Angel Fund</em></li>
                <li><em>Launching &ndash; HK$ 10million External Funds</em></li>
              </ol>
              <p>Two members from our team have been successful in presenting our project to investors through this programme. Currently, we are in the Seeding stage and have raised HK$ 100,000 as seed investment for our start-up as well as acceptance in the Hong Kong Science and Technology Park Ideation Programme for the next year.</p>

            </section>
            
            <div>
              <section id="Ideation">
              <img src="https://static.igem.wiki/teams/4154/wiki/assets/team-photo-web.jpeg" alt="" />
              <p style={{textAlign:'center'}}>What is the Ideation Programme?</p>
              <br />
              <br />
              <br />

              <p>Through this programme by Hong Kong Science Park you will be able to <u>learn the fundamental skills needed to kickstart your business</u> and turn ideas into reality. The programme offer&rsquo;s one year of start-up support, from designing a business model to finding investment.</p>
              <p>The programme includes access to:</p>
              <ol>
                <li><em>Mentos</em> &ndash; for business advice</li>
                <li><em>Training</em> &ndash; Hong Kong start-up ecosystem, Business modelling, Pitching and investment, etc.</li>
                <li><em>Co-working space</em></li>
                <li><em>Opportunity to get accepted into HKSTP&rsquo;s Incubation programme</em>.</li>
              </ol>
              <p><u>To better describe our product, we have also conducted a <strong>SWOT analysis</strong>:</u></p>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <p><strong><u>Strengths: </u></strong></p>
                      <p>● Drug resistance is much less of an obstacle because of a significant chemical library and possibly modifications.</p>
                      <p>● Not involving any environmentally hazardous compounds hence it is eco-friendly</p>
                      <p>● Less toxic to non-cancerous cells as compared to common drugs</p>
                      <p>● Potentially, can have affordable price</p>
                    </td>
                    <td>
                      <p><strong><u>Weaknesses</u></strong>:</p>
                      <p>● Can be less effective (targets fewer cancer cells) than common types of anticancer drugs</p>
                      <p>● Still need time for research and experiments</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p><strong><u>Opportunities</u></strong>:</p>
                      <p>● The market is in a developing stage. Currently, more than 60% of synthetic drugs are derived from natural sources and such percentage continues to increase. Our strategy lets us synthesise a variety of novel natural product derivatives giving us access to a large market share. (Sharifi-Rad et al., 2019)</p>
                    </td>
                    <td>
                      <p><strong><u>Threats</u></strong>:</p>
                      <p>● Man-made mutations</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              </section>
              
            </div>
          </section>
          
        </div>
      </section>
    </div>
  );
}

export default Entrepreneurship;
